import type { GetAttributeFunction } from "@v1/types/get-attribute-function";
import type { ComponentMapping } from "replo-runtime/shared/Component";

export const CONTROL_BOX_HEIGHT = 28;

export function isEqualBoundingBox(
  box1: { top: number; left: number; width: number; height: number },
  box2: { top: number; left: number; width: number; height: number },
) {
  return (
    box1.top === box2.top &&
    box1.left === box2.left &&
    box1.width === box2.width &&
    box1.height === box2.height
  );
}

export function getChildBoxRenderComponentIds(
  componentMapping: ComponentMapping,
  draftComponentId: string | null,
  getAttribute: GetAttributeFunction,
) {
  if (!draftComponentId) {
    return [];
  }

  const childBoxRenderComponents: string[] = [draftComponentId];

  let currentComponentId = draftComponentId;
  while (componentMapping?.[currentComponentId]?.parentComponent?.id) {
    const parentComponent =
      componentMapping?.[currentComponentId]?.parentComponent;
    currentComponentId = parentComponent!.id;

    // Note (Ovishek, 2022-11-4): For ancestor who has a display grid
    // we are rendering childBoxes for all of them. B/c for grid the layout
    // can be complicated and if any of the children is selected there remains no clue to the layout itself.
    // In this way we highlight all the ancestors grid layout by pink and let the user a better user experience.
    if (getAttribute(parentComponent!, "style.display").value === "grid") {
      childBoxRenderComponents.push(currentComponentId);
    }
  }

  return childBoxRenderComponents;
}
